module.exports = __webpack_public_path__ + "img/sp.0cb3402a.png";